import apiClient from './apiService';
import {parseFiltersToQueryString} from "../utils/parseFiltersToQueryString";

class SectionalService {
    constructor() {
        if (SectionalService.instance) {
            return SectionalService.instance;
        }
        SectionalService.instance = this;
    }

    async getAll(filters = {}) {
        try {
            const queryString = parseFiltersToQueryString(filters);
            const response = await apiClient.get(`/sectionals?${queryString}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async getAllWithPagination(filters = {}, page = 1, limit = 10) {
        try {
            const queryString = parseFiltersToQueryString(filters);
            const params = new URLSearchParams(queryString);
            params.append("page", page);
            params.append("size", limit);
            const response = await apiClient.get(`/sectionals?${params.toString()}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static getInstance() {
        if (!SectionalService.instance) {
            SectionalService.instance = new SectionalService();
        }
        return SectionalService.instance;
    }
}

export default SectionalService.getInstance();
